import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { CustomersAiIcon, MetaIcon, XRayIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import styles from './QualityScore.module.css';

export const QualityScore = ({
  website,
  pageView,
  isMobile,
  isWhiteLabel,
}: {
  website: string;
  pageView: number;
  isMobile?: boolean;
  isWhiteLabel?: boolean;
}) => {
  const discounted = [
    { num: 50, idx: 10 },
    { num: 44.2, idx: 9 },
    { num: 37.5, idx: 8 },
    { num: 28.6, idx: 7 },
  ];

  const increased = [
    { num: 20.7, idx: 5 },
    { num: 25, idx: 4 },
    { num: 67.3, idx: 3 },
    { num: 73, idx: 2 },
    { num: 400, idx: 1 },
  ];

  const greenBlock = (
    <div className={classNames(styles.scaleBlock, styles.green)}>
      <div className={styles.scale}>
        {discounted.map(item => (
          <div className={styles.scaleRow} key={item.idx}>
            <span className={styles.rowIndex}>{item.idx}</span>
            <div
              className={styles.barGreen}
              style={
                !isMobile
                  ? { width: `${item.num}%` }
                  : { height: `${item.num}%` }
              }
            >
              <span className={styles.barLabel}>discounted</span>
            </div>
            <div className={styles.num}>
              <ArrowDownOutlined className={styles.arrowDown} /> {item.num}%
            </div>
          </div>
        ))}
      </div>
      <span className={styles.text}>
        Meta Rewards accounts with high quality scores
      </span>
    </div>
  );

  const redBlock = (
    <div className={classNames(styles.scaleBlock, styles.red)}>
      <div className={styles.scale}>
        {increased.map(item => (
          <div className={styles.scaleRow} key={item.idx}>
            <span className={styles.rowIndex}>{item.idx}</span>
            <div
              className={classNames(styles.barGreen, styles.barRed)}
              style={
                !isMobile
                  ? { width: `${item.num}%` }
                  : { height: `${item.num}%` }
              }
            >
              <span className={styles.barLabel}>increased</span>
            </div>
            <div className={styles.num}>
              <ArrowUpOutlined className={styles.arrowUp} />{' '}
              {item.idx === 2 ? '150' : item.num}%
            </div>
          </div>
        ))}
      </div>
      <span className={styles.text}>
        Meta “Taxes” accounts with low quality score
      </span>
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.dataBlock}>
        <div className={styles.websiteData}>
          <span className={classNames(styles.score, styles.greenScore)}>
            8.2
            <span className={styles.operator}>=</span>
            <CustomersAiIcon />
            <span className={styles.operator}>+</span>
            <XRayIcon color="#B770E2" />
          </span>

          <div>
            Your event match quality score
            <br />
            <span style={{ fontWeight: 700 }}>
              with {isWhiteLabel ? 'our tool' : 'Customers.ai Super-Pixel'}{' '}
            </span>
          </div>
        </div>
        <div className={styles.websiteData}>
          <span className={classNames(styles.score, styles.redScore)}>
            {pageView}
          </span>
          <div>
            <span className={styles.link}>{website}</span>'s event match
            <br /> quality score
          </div>
        </div>
      </div>
      <div>
        <div className={styles.heading}>Quality score</div>
        <div className={styles.content}>
          {isMobile ? redBlock : greenBlock}
          <div className={classNames(styles.scaleRow, styles.metaRow)}>
            <span className={styles.rowIndex}>6</span>
            <div
              className={classNames(styles.barGreen, styles.barMeta)}
              style={!isMobile ? { width: 115 } : { height: 55 }}
            />
            <MetaIcon color="#0082FB" />
            <div className={styles.num}>Meta benchmark</div>
          </div>
          {isMobile ? greenBlock : redBlock}
        </div>
      </div>
    </div>
  );
};
